module.exports = __webpack_public_path__ + "static/media/logo.f26bb754.svg";